import { useEffect } from 'react';
import {
  ChatFeedbackModal,
  useFeedback,
  CHATAI_LOADING_STATUS,
  ChatAIInput,
  useChatContext,
} from '@ltvco/refresh-lib/v2';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { MessagesContainer } from './MessagesContainer';
import { CameraAltOutlined } from '@mui/icons-material';
import { theme } from 'theme';
import { FeatureHeader } from '../components/FeatureHeader';
import { FeaturePageShell } from '../components/FeaturePageShell';

export const DamageAnalyzerPage = () => {
  const { isMobile } = useScreenSize();
  const { messages, loadingStatus, sendMessage, handleFeatureNameChange } =
    useChatContext();
  const {
    openFeedback,
    thumbsUp,
    currentResponseId,
    feedback,
    createFeedback,
    updateFeedback,
    handleCloseFeedback,
  } = useFeedback(messages);

  useEffect(() => {
    handleFeatureNameChange('createVehiclePhotoDamageAnalyzerBot');
  }, [handleFeatureNameChange]);

  return (
    <FeaturePageShell
      header={
        <FeatureHeader
          icon={
            <CameraAltOutlined sx={{ color: theme.palette.primary.main }} />
          }
          title="Photo Damage Analyzer"
        />
      }
      feedbackModal={
        <ChatFeedbackModal
          open={openFeedback}
          onClose={handleCloseFeedback}
          thumbsUp={thumbsUp}
          responseItemId={currentResponseId}
          createFeedback={createFeedback}
          updateFeedback={updateFeedback}
          hasRecord={
            typeof feedback[currentResponseId]?.thumbs_up === 'boolean'
          }
          feedbackText={
            feedback[currentResponseId]?.feedback?.feedback_text || ''
          }
        />
      }
      chatInput={
        <ChatAIInput
          isLoading={
            loadingStatus.message !== CHATAI_LOADING_STATUS.IDLE.message
          }
          disabled={messages.length === 0}
        />
      }
    >
      <MessagesContainer
        messages={messages}
        loadingStatus={loadingStatus}
        onSendMessage={sendMessage}
      />
    </FeaturePageShell>
  );
};
